import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { UsersView } from './Users';

import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { ROUTE_PATHS } from '@/config/constants';

export function AdminUsers() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh' }}>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-4xl font-bold">Users</h1>
        <Button onClick={() => navigate(ROUTE_PATHS.ADMIN_USERS_CREATE)}>
          {' '}
          <Plus className="mr-2 h-4 w-4" /> Create New User{' '}
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>All Users</CardTitle>
        </CardHeader>
        <CardContent>
          <UsersView />
        </CardContent>
      </Card>
    </div>
  );
}
